<template>
  <DropdownMenuItem class="DropdownMenuItem" @click="$emit('click')" :class="{ danger: color === 'danger' }">
    <slot />
  </DropdownMenuItem>
</template>

<script>
  import { DropdownMenuItem } from 'radix-vue';

  export default {
    name: 'WDropdownMenuItem',
    components: { DropdownMenuItem },
    emits: ['click'],
    props: {
      color: {
        type: String,
        default: 'default',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/variables';

  .DropdownMenuItem {
    min-width: 180px;
    font-size: 0.875rem;
    padding: 0.5rem 0.75rem;
    cursor: pointer;
    border-radius: 0.5rem;

    transition: all ease 0.4s;

    &[data-highlighted] {
      background-color: $bg-dark;
      border: none;
      outline: solid 0px #0000;
    }

    .default {
      color: $neutral-black;
    }

    &.danger {
      color: $communication-danger;
    }
  }
</style>
